import ToggleWithLabels from './ToggleWithLabels';

export default ToggleWithLabels;
